import { useEffect } from 'react'
import { useIsScreenLoading, useLocation } from '@muse-web/router'
import {
    onSessionRotation,
    sendSessionStartEvent,
    syncAnalyticsContext,
    useSessionStartTracking,
} from '@core/analytics'

type TSessionContextTrackerProps = {
    userId: number
}

/** Owns the per-navigation half of the shell's analytics — keeps `useLocation` off the other trackers. */
export const SessionContextTracker = ({ userId }: TSessionContextTrackerProps) => {
    const { pathname } = useLocation()
    const isScreenLoading = useIsScreenLoading()

    // Chained, not two effects and not a child component: on a brand-new visitor the first-session
    // id does not exist until syncAnalyticsContext writes it, and reporting before that claims the
    // session for `Session Start` — so `First Session` could never fire for that client again.
    useEffect(() => {
        if (isScreenLoading) {
            return
        }

        syncAnalyticsContext(userId).then(sendSessionStartEvent)
    }, [pathname, userId, isScreenLoading])

    useEffect(
        () =>
            onSessionRotation(() => {
                syncAnalyticsContext(userId).then(sendSessionStartEvent)
            }),
        [userId],
    )

    useSessionStartTracking()

    return null
}
